import {AxiosInstance, AxiosResponse} from 'axios';
import {
    MemberRegistrationRepository,
    ResetRegistrationCodeResponse
} from '@/model/repository/manager/members/MemberRegistrationRepository';

export default (Repository: AxiosInstance) =>
    (resource: string): MemberRegistrationRepository => ({
        resetRegistrationCode(id): Promise<AxiosResponse<ResetRegistrationCodeResponse>> {
            const endpoint = resource.replace('{id}', id);
            // ボディが不要なリクエストだが、空にすると axios が Content-Type を落とすため空オブジェクトを渡す。
            // Content-Type が無いと CSRF 多層防御の Content-Type チェックを通せず、
            // 対象を URL だけで指定できるこのエンドポイントがクロスサイトから叩ける状態になる。
            return Repository.post(endpoint, {});
        },
    });
